import { getNexonUrl } from "@/lib/utils";
import { ErrorCodeType, ErrorType } from "@/types";
import { isMobile } from "react-device-detect";
import useMessageModal from "@/hooks/useMessageModal";
import { ERROR_MESSAGE } from "@/consts/errors";
import { getParentAgreementToken, getCancelWithdrawalToken, getUnprotectToken } from "@/lib/nest";

const EXCEPT_ERROR_LIST = [
  "already_exists_account",
  "not_exists_request_parent_agreement",
  "not_exists_account",
  "not_withdrawal_grace_period",
];

export const useFailure = () => {
  const { showMessageModal } = useMessageModal();

  const handleRedirectFailure = async (
    error: ErrorType,
    params?: {
      setErrorCode?: React.Dispatch<React.SetStateAction<ErrorCodeType | undefined>>;
      accesscode?: number;
      keepLogin?: 0 | 1;
    },
  ) => {
    const code = error.code;
    const { state } = error.appendix || {};

    try {
      let token = "";
      switch (code) {
        // 해외 로그인 차단
        case "blocked_international_signin":
          window.location.href = `/auth/loginblock?state=${state}`;
          break;
        // 보호자 가입 동의
        case "request_parent_agreement":
          token = await getParentAgreementToken(state ?? "");
          window.location.href = `${import.meta.env.VITE_MYINFO_URL}/signup-waiting?crypt=${token}`;
          break;
        // 회원탈퇴 유예
        case "withdrawal_grace_period":
          token = await getCancelWithdrawalToken(state ?? "");
          window.location.href = `${import.meta.env.VITE_MYINFO_URL}/cancel-withdrawal?crypt=${token}`;
          break;
        // ID 보호잠금 설정 (보호모드)
        case "protected_by_nass":
          if (isMobile) {
            alert(
              "고객님의 넥슨ID는 현재 보호모드가 적용 중입니다. \nPC환경에서 넥슨닷컴에 로그인하시면 본인확인 후 비밀번호 재설정을 통하여 안전하게 로그인할 수 있습니다.",
            );
            return;
          }
          token = await getUnprotectToken(state ?? "");
          window.location.href = `${import.meta.env.VITE_PROTECT_ID_URL}?token=${token}&accessCode=${params?.accesscode ?? 0}&keepLogin=${params?.keepLogin ?? 0}`;
          break;
        default:
          return;
      }
    } catch (error: unknown) {
      const { code } = error as ErrorType;

      if (params?.setErrorCode) {
        params.setErrorCode(code);
      }

      if (EXCEPT_ERROR_LIST.includes(code)) {
        showMessageModal({
          message: ERROR_MESSAGE[code] || "잘못된 접근입니다.",
          callback: () => {
            window.location.href = getNexonUrl();
          },
        });
      }
    }
  };

  return { handleRedirectFailure };
};
